import { useCallback } from 'react';

import { getFlagsManager } from './manager';
import { type AddFlagProps } from './types';

export function useFlags() {
  const addFlag = useCallback((props: AddFlagProps) => {
    const flagsManager = getFlagsManager();

    // this method cannot be destructured because it is a class and will lose "this" context
    flagsManager.addFlag(props);
  }, []);

  const clearFlags = useCallback(() => {
    const flagsManager = getFlagsManager();
    return flagsManager.clearFlags();
  }, []);

  return {
    addFlag,
    clearFlags,
  };
}
